<app-breadcrumbs title="Inventory Transactions" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <!-- Header -->
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <!-- <i class="ri-checkbox-circle-line align-middle me-1"></i> -->
          Transactions History
        </h5>
      </div>

      <!-- Filters -->
      <div class="card-body border-bottom">
        <div class="row g-3">

          <div class="col-md-3">
            <label class="form-label">Item</label>
            <select class="form-control" [(ngModel)]="itemId">
              <option value="">All Items</option>
              <option *ngFor="let item of items" [value]="item.id">
                {{ item.name }} ({{ item.code }})
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label">Transaction Type</label>
            <select class="form-control" [(ngModel)]="transactionType">
              <option value="">All</option>
              <option value="In">In</option>
              <option value="Out">Out</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">From Date</label>
            <input type="date" class="form-control" [(ngModel)]="fromDate" />
          </div>

          <div class="col-md-2">
            <label class="form-label">To Date</label>
            <input type="date" class="form-control" [(ngModel)]="toDate" />
          </div>

          <div class="col-md-2 d-flex align-items-end gap-2">
            <button class="btn btn-primary" (click)="applyFilters()">
              <i class="ri-search-line align-bottom me-1"></i> Search
            </button>
            <button class="btn btn-light" (click)="resetFilters()">
              <i class="ri-refresh-line align-bottom"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card-body pt-0">
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading" class="table-responsive table-card mb-0">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>Transaction Number</th>
                <th>Item Name</th>
                <th>Transaction Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="transactionList.length === 0">
                <td colspan="9" class="text-center py-4">
                  <div class="text-muted">
                    <i class="ri-inbox-line fs-1"></i>
                    <p class="mt-2">No pending quality check items found</p>
                  </div>
                </td>
              </tr>

              <tr *ngFor="let data of transactionList">
                <td>{{ data.transactionNumber || '-' }}</td>
                <td>{{ data?.item?.name || '-' }}</td>
                <td>{{ data.movementType || '-' }}</td>
                <td>{{ data.createdAt | date: 'mediumDate' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="totalRecords > 0 && !isLoading">
          <div class="col col-sm-6">
            <div class="dataTables_info mb-2">
              Showing {{ ((page - 1) * pageSize) + 1 }} to {{ (page * pageSize) > totalRecords ? totalRecords : (page * pageSize) }} of {{ totalRecords }} entries
            </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination [collectionSize]="totalRecords" 
                              [(page)]="page" 
                              [pageSize]="pageSize" 
                              (pageChange)="changePage()">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
